import { snackbar } from "@/core/controller/snackbar_controller";
import { headers } from '../const/headers';
import { VisitServiceOrderDefault } from "../domain/visitServiceOrder/visitServiceOrder";
import ServiceOrderReport from "@/helpers/serviceOrderReport";
import { ServiceOrderReportImageDefault } from "../domain/visitServiceOrder/serviceOrderReportImage";
import dayjs from "dayjs";

class VisitServiceOrderController {
    context = null;
    headers = headers;
    loading = false;
    loadingUpdateStatus = false
    search = "";
    dialog = false;
    dialogUpdateStatus = false
    formUpdateStatus = {}
    searchClient = "";
    searchVehicle = "";
    searchTechnician = "";
    searchTaskType = "";
    searchStatus = "";
    searchStatusInUpdateModal = "";
    statusSelected = 0;
    currentField = null
    videoStream = null;
    photoData = {};
    constraints = {
        id: 0,
        video: false,
        width: {
            min: 1280,
            ideal: 1920,
            max: 2560,
        },
        height: {
            min: 720,
            ideal: 1080,
            max: 1440,
        },
        facingMode: "environment",
    };
    rules = [ value => !value || value.size <  2000000 || 'O tamanho do arquivo deve ser menor que 2 MB.']
    formDynamic = false
    fields = []
    form = VisitServiceOrderDefault()
    formImage = ServiceOrderReportImageDefault()
    uploadedImages = []
    cameraReference = {}
    formSchema = null
    dynamicRequired = {}
    startDate = dayjs()
    startDate = dayjs().toISOString()
    tabs = []
    currentTab = 0
    totalProperties = 0
    patchTimers = {}
    patchInFlight = {}
    patchPending = {}
    savingState = {}
    errorState = {}
    uploadLoading = {}
    imageLoading = {}
    signatureRefs = {}
    signatureCtx = {}
    signatureDrawing = {}
    photoMode = {}
    statusSelected = 1;
    statusPaginated = 1;
    statusList = [
        {text: 'Todos', value: 0},
        {text: 'Ativo', value: 1},
        {text: 'Inativo', value: 2}
    ];
  
    serviceOrderPagination = {
        total: 0,
        items: []
    }

  isReportComplete() {
    return true;
  }

  onTabsInput(nextIndex) {
    try {
      const nNext = Number(nextIndex)

      if (Number.isNaN(nNext)) return;

      this.currentTab = nNext
      this.tabs = nNext
    } catch (_) {
      this.tabs = this.currentTab
    }
  }

  canEnterTab(index) {
    return true;
  }

  cancelPendingPatches() {
    try {
      Object.values(this.patchTimers || {}).forEach(t => clearTimeout(t))
    } catch (_) {}
    this.patchTimers = {}
    this.patchPending = {}
  }

  scrollToFirstError() {
    try {
      const el = document.querySelector('.v-input.error--text, .v-messages__message.error--text')
      if (el && el.scrollIntoView) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    } catch (_) {}
  }

  async submitReport() {
    try {
      if (!this.isReportComplete || !this.isReportComplete()) {
        snackbar.show({ message: "Finalize todo o relatório antes de enviar.", color: "#DEZ728", timeout: 3000 })
        return
      }
      if (this.form.approvedDate) {
        snackbar.show({ message: "Relatório já aprovado.", color: "#C0CA33", timeout: 3000 })
        return
      }
      
      this.cancelPendingPatches()
      this.form.submittedDate = dayjs().toISOString()
      this.form.status = 'PENDING_APPROVED'
      const snapshot = JSON.parse(JSON.stringify(this.form.reportData))
      const payload = {
        reportData: snapshot,
        status: this.form.status,
        submittedDate: this.form.submittedDate,
        approvedDate: this.form.approvedDate || null,
      }
      const confirm = await this.patchServiceOrderReportIdReportItemUseCaseImpl(this.form.id, payload)
      if (confirm) {
        snackbar.show({ message: "Relatório enviado para aprovação.", color: "#008000", timeout: 3000 })
        await this.paginate()
        this.formDynamic = false
        try { this.clearAllCameras() } catch (_) {}
      }
    } catch (error) {
      snackbar.show({ message: error?.toString() || "Não foi possível enviar o relatório", color: "#ff0000", timeout: 3000 })
    }
  }

  async approveReport(item) {
    try {
      if (!this.isReportComplete || !this.isReportComplete()) {
        snackbar.show({ message: "Finalize todo o relatório antes de aprovar.", color: "#DEZ728", timeout: 3000 })
        return
      }
      const now = dayjs().toISOString()
      const targetId = item?.id || this.form.id
      const current = await this.getServiceOrderByIDReportUseCaseImpl(targetId)
      const payload = {
        approvedDate: now,
        submittedDate: current?.submittedDate || item?.submittedDate || null,
        status: 'APPROVED',
        reportData: current?.reportData || this.form.reportData || item?.reportData || {}
      }

      const confirm = await snackbar.confirm({ message: "Aprovar relatório? ", color: "primary", timeout: 5000 })
      if (confirm) {
        await this.patchServiceOrderReportIdReportItemUseCaseImpl(targetId, payload)
        snackbar.show({ message: "Relatório aprovado.", color: "#008000", timeout: 3000 })
        await this.paginate()
        this.formDynamic = false
        try { this.clearAllCameras() } catch (_) {}
      }
    } catch (error) {
      snackbar.show({ message: error?.toString() || "Não foi possível aprovar o relatório", color: "#ff0000", timeout: 3000 })
    }
  }

    options = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["createdDate"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: [true]
    }


    clientPagination = {
        total: 0,
        items: []
    }
    
    clientOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["id"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    vehiclePagination = {
        total: 0,
        items: []
    }
    
    vehicleOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["plate"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    technicianPagination = {
        total: 0,
        items: []
    }
    
    technicianOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["name"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    statusPagination = {
        total: 0,
        items: []
    }

    statusOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["id"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    taskTypePagination = {
        total: 0,
        items: []
    }

    taskTypeOptions = {
        page: 1,
        itemsPerPage: 40,
        groupBy: [],
        sortBy: ["id"],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
        sortDesc: []
    }

    constructor(
        context,
        fetchClientUseCaseImpl,
        fetchVehicleUseCaseImpl,
        fetchServiceOrderUseCaseImpl,
        fetchTechnicianUseCaseImpl,
        fetchTaskTypeUseCaseImpl,
        fetchStatusUseCaseImpl,
        changeServiceOrderUsecaseImpl,
        getServiceOrderByIDReportUseCaseImpl,
        patchServiceOrderReportIdReportItemUseCaseImpl,
        createServiceOrderReportImageUseCaseImpl,
        changeServiceOrderReportImageUseCaseImpl,
        createConfirmImageUploadUseCaseImpl
    ) {
        this.context = context;
        this.fetchClientUseCaseImpl = fetchClientUseCaseImpl,
        this.fetchVehicleUseCaseImpl = fetchVehicleUseCaseImpl,
        this.fetchServiceOrderUseCaseImpl = fetchServiceOrderUseCaseImpl,
        this.fetchTechnicianUseCaseImpl = fetchTechnicianUseCaseImpl,
        this.fetchTaskTypeUseCaseImpl = fetchTaskTypeUseCaseImpl,
        this.fetchStatusUseCaseImpl = fetchStatusUseCaseImpl,
        this.changeServiceOrderUsecaseImpl = changeServiceOrderUsecaseImpl,
        this.getServiceOrderByIDReportUseCaseImpl = getServiceOrderByIDReportUseCaseImpl,
        this.patchServiceOrderReportIdReportItemUseCaseImpl = patchServiceOrderReportIdReportItemUseCaseImpl,
        this.createServiceOrderReportImageUseCaseImpl = createServiceOrderReportImageUseCaseImpl,
        this.changeServiceOrderReportImageUseCaseImpl = changeServiceOrderReportImageUseCaseImpl,
        this.createConfirmImageUploadUseCaseImpl = createConfirmImageUploadUseCaseImpl
    }

    async paginate() {
        this.loading = true
        try {
            this.serviceOrderPagination = await this.fetchServiceOrderUseCaseImpl(this.options, this.search, this.statusSelected)
        } catch (error) {
            console.log(error);
        } finally {
            this.loading = false
        }
    }
    async taskTypePaginate() {
        try {
            this.taskTypePagination = await this.fetchTaskTypeUseCaseImpl(this.taskTypeOptions, this.searchTaskType)
        } catch (error) {
            console.log(error);
        }
    }
    async clientPaginate() {
        try {
          this.clientPagination = await this.fetchClientUseCaseImpl(
            this.clientOptions,
            this.searchClient,
            this.statusPaginated
          )
        } catch (error) {
          console.log(error);
        }
    }
    async vehiclePaginate() {
        try {
          this.vehiclePagination = await this.fetchVehicleUseCaseImpl(
            this.vehicleOptions,
            this.searchVehicle,
            this.statusPaginated
          )
        } catch (error) {
          console.log(error);
        }
    }
    async technicianPaginate() {
        try {
          this.technicianPagination = await this.fetchTechnicianUseCaseImpl(
            this.technicianOptions,
            this.searchTechnician,
            this.statusPaginated
          );
        } catch (error) {
          console.log(error);
        }
    }
    async statusPaginate() {
        try {
            this.statusPagination = await this.fetchStatusUseCaseImpl(this.statusOptions, this.searchStatus)
        } catch (error) {
            console.log(error);
        }
    }

    changeStatus() {
        this.paginate()
    }
    watchOptions() {
        this.paginate()
    }
    watchSearch() {
        this.paginate()
    }
    watchClientOptions() {
        this.clientPaginate()
    }
    watchClientSearch() {
        this.clientPaginate()
    }
    watchVehicleOptions() {
        this.vehiclePaginate()
    }
    watchVehicleSearch() {
        this.vehiclePaginate()
    }
    watchTechnicianOptions() {
        this.technicianPaginate()
    }
    watchTechnicianSearch() {
        this.technicianPaginate()
    }
    watchTaskTypeOptions() {
        this.taskTypePaginate()
    }
    watchTaskTypeSearch() {
        this.taskTypePaginate()
    }
    watchStatusOptions() {
        this.statusPaginate()
    }
    watchStatusSearch() {
        this.statusPaginate()
    }

async updateStatusOpen(data) {
    this.dialogUpdateStatus = true
    this.formUpdateStatus = { ...data }
    this.searchStatus = data.serviceOrderStatusID

    await this.statusPaginate()
  }

  closeUpdateStatus() {
     this.dialogUpdateStatus = false;
     this.formUpdateStatus = {}
     this.searchStatus = ""
  }

  async updateStatus() {
    if (this.context.$refs.crudUpdateStatus.validate()) {
      try {
        this.loadingUpdateStatus = true
        await this.changeServiceOrderUsecaseImpl(this.formUpdateStatus.id, this.formUpdateStatus)
        snackbar.show({ message: "Alterado com sucesso!!!", color: "#008000", timeout: 3000 })
        this.closeUpdateStatus()
        this.paginate()
      } catch (error) {
        snackbar.show({ message: error.toString(), color: "#ff0000", timeout: 3000 })
      } finally {
        this.loadingUpdateStatus = false
      }
    }
  }

  async openForm() {
    this.dialogForm = true;
  }

  async stopVideo() {
    if (!this.videoStream) return

    try {
      this.videoStream.getTracks().forEach(track => {
        track.stop()
      })
      this.videoStream = null
      this.constraints.video = false
    } catch (error) {
      console.warn('Erro ao parar vídeo: ', error)
    }
  }

  setCameraReference(index, video) {
    if (index.key) {
        index = index.key  
    }
    
    if (video) {
        this.cameraReference[index] = video
    }
  }

  clearCameraReference(index) {
    if (index && this.cameraReference[index]) {
      try {
        this.cameraReference[index].srcObject = null
      } catch (_) {}
      delete this.cameraReference[index]
    }
  }

  clearAllCameras() {
    try { this.stopVideo() } catch (_) {}
    this.constraints.video = false
    this.videoStream = null
    try {
      Object.keys(this.cameraReference || {}).forEach(k => {
        const video = this.cameraReference[k] 
        if (video && video.srcObject) {
          video.srcObject = null
        }
        delete this.cameraReference[k]
      })
      this.cameraReference = {}
    } catch (_) {}
  }

  deactivateAllCamerasExcept(exceptId) {
    try {
      Object.entries(this.cameraReference || {}).forEach(([k, video]) => {
        if (String(k) !== String(exceptId) && video) {
          try { video.srcObject = null } catch (_) {}
        }
      })
    } catch (_) {}
  }

  async initializeCamera(field, fieldIndex) {
    const key = field.key || fieldIndex

    await this.clearAllCameras()
    this.constraints.id = key

    try {
      let stream = null
      try {
        stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: this.constraints.facingMode || 'environment'
          }
        })
      } catch (e1) {
        console.warn('getUserMedia com facingMode falhou:', e1?.name || e1)
        stream = await navigator.mediaDevices.getUserMedia({ video: true })
      }

      this.videoStream = stream
      this.constraints.video = true

      const tryGetVideoRef = async (attempts = 10, delayMs = 100) => {
        for (let i = 0; i < attempts; i++) {
          const v = this.cameraReference[key]
          if (v && v.tagName === 'VIDEO') return v
          if (this.vue && this.vue.$nextTick) {
            await this.vue.$nextTick()
          }
          await new Promise(r => setTimeout(r, delayMs))
        }
        return null
      }

      const video = await tryGetVideoRef(15, 80)

      if (!video) throw new Error(`Elemento de vídeo não encontrado para key: ${key}`)

      setTimeout(() => {
        window.scrollTo({
          top: 100,
          behavior: 'smooth'
        })
      }, 600)
      
      try { video.muted = true } catch (_) {}
      try { video.playsInline = true } catch (_) {}
      video.srcObject = this.videoStream
      try { await video.play() } catch (ePlay) {
        console.warn('Falha ao iniciar reprodução do vídeo:', ePlay?.name || ePlay)
      }

    } catch (error) {
      console.error('❌ Erro ao iniciar câmera:', error?.name || error, error)
      snackbar.show({
        message: "Erro ao acessar a câmera",
        color: "#ff0000",
        timeout: 3000
      })
      await this.clearAllCameras()
    }
  }

  clearPhoto() {
    const canvas = this.context.$refs.canvas
    const photo = this.context.$refs.photo
    
    const context = canvas.getContext("2d");
    context.fillStyle = "#aaaaaa"
    context.fillRect(0, 0, canvas.width, canvas.height);

    const data = canvas.toDataURL("image/png");
    photo.setAttribute("src", data);
  }

  async takePicture(field, index) {
    if (field.key) {
        index = field.key
    }
    const video = this.cameraReference[index]
    const canvas = document.createElement("canvas")
    const context = canvas.getContext("2d");
    const width = video.videoWidth || 300;
    const height = video.videoHeight || 200;

    
    if (width && height) {
        canvas.width = width;
        canvas.height = height;
        context.drawImage(video, 0, 0, width, height)

        await this.stopVideo()
        this.constraints.video = false
        const dataUrl = canvas.toDataURL("image/jpeg", 0.8)
        try {
          const current = Array.isArray(this.form.images) ? this.form.images : []
          const filtered = current.filter(img => img?.formFieldKey !== index)
          this.form.images = [...filtered, { formFieldKey: index, signURL: dataUrl, temp: true }]
          this.setImageLoading(index, true)
        } catch (_) {}

        const blob = await (await fetch(dataUrl)).blob()
        const file = new File([blob], `${index}.jpeg`, { type: "image/jpeg" })

        const ok = await this.serviceOrderReportImage(file, index)
        if (ok) {
          snackbar.show({ message: "Foto salva com sucesso!", color: "#008000", timeout: 3000 })
        } else {
          try {
            const current = Array.isArray(this.form.images) ? this.form.images : []
            this.form.images = current.filter(img => img?.formFieldKey !== index)
          } catch (_) {}
          snackbar.show({ message: 'Falha ao enviar a imagem. Verifique sua conexão e tente novamente.', color: '#ff0000', timeout: 3000 })
        }

        try { this.stopVideo() } catch (_) {}
        this.constraints.video = false
        this.clearCameraReference(index)

    } else {
        this.clearPhoto();
    }
  }

  setSignatureReference(key, canvas) {
    if (!canvas) return
    this.signatureRefs[key] = canvas
    const ctx = canvas.getContext('2d')
    ctx.lineWidth = 2
    ctx.lineCap = 'round'
    this.signatureCtx[key] = ctx
  }

  _sigPos(key, e) {
    const c = this.signatureRefs[key]
    if (!c) return { x: 0, y: 0 }
    const rect = c.getBoundingClientRect()
    if (e.touches && e.touches[0]) {
      return { x: e.touches[0].clientX - rect.left, y: e.touches[0].clientY - rect.top }
    }
    return { x: e.clientX - rect.left, y: e.clientY - rect.top }
  }

  signatureStart(key, e) {
    this.signatureDrawing[key] = true
    const p = this._sigPos(key, e)
    const ctx = this.signatureCtx[key]
    if (!ctx) return
    ctx.beginPath()
    ctx.moveTo(p.x, p.y)
  }

  signatureMove(key, e) {
    if (!this.signatureDrawing[key]) return
    const p = this._sigPos(key, e)
    const ctx = this.signatureCtx[key]
    if (!ctx) return
    ctx.lineTo(p.x, p.y)
    ctx.stroke()
  }

  signatureEnd(key) {
    this.signatureDrawing[key] = false
  }

  clearSignature(key) {
    const c = this.signatureRefs[key]
    const ctx = this.signatureCtx[key]
    if (c && ctx) ctx.clearRect(0, 0, c.width, c.height)
  }

  async saveSignature(key) {
    const c = this.signatureRefs[key]
    if (!c) return
    const dataUrl = c.toDataURL('image/png')
    try {
      const current = Array.isArray(this.form.images) ? this.form.images : []
      const filtered = current.filter(img => img?.formFieldKey !== key)
      this.form.images = [...filtered, { formFieldKey: key, signURL: dataUrl, temp: true }]
    } catch (_) {}
    await this.serviceOrderReportSignature(dataUrl, key)
  }

  async serviceOrderReportSignature(dataUrl, fieldKey) {
    const blob = await (await fetch(dataUrl)).blob()
    this.setUploading(fieldKey, true)
    try {
      const formImage = {
        contentType: 'image/png',
        fileName: `${fieldKey}.png`,
        formFieldKey: fieldKey,
        serviceOrderReportID: this.form.id,
        fileSize: blob.size
      }
      this.setImageLoading(fieldKey, true)

      const response = await this.createServiceOrderReportImageUseCaseImpl(formImage)
      if (response?.signURL) {
        await this.changeServiceOrderReportImageUseCaseImpl(response.signURL, blob)
        const payload = {
          serviceOrderReportId: formImage.serviceOrderReportID,
          s3Key: response.s3Key,
          formFieldKey: response.formFieldKey,
          caption: ""
        }
        await this.createConfirmImageUploadUseCaseImpl(payload)
        try {
          const resp = await this.getServiceOrderByIDReportUseCaseImpl(this.form.id)
          this.form.images = resp.images || []
        } catch (_) {}
      }
    } catch (error) {
      snackbar.show({ message: error?.toString() || 'Não foi possível salvar a assinatura', color: '#ff0000', timeout: 3000 })
    } finally {
      this.setUploading(fieldKey, false)
      this.setImageLoading(fieldKey, false)
    }
  }

  async openFormDynamic(item) {   
    this.form = { ...item }
    this.form.reportData = this.form.reportData || {}
    this.currentTab = 0
    this.tabs = 0
    
    this.fields = [] 
    this.formSchema = null
    
    try {
      this.loading = true
        if (this.form) {
            const late = await this.getServiceOrderByIDReportUseCaseImpl(this.form.id)
            if (late.approvedDate) {
              snackbar.show({ message: "Relatório já aprovado. Edição não permitida.", color: "#C0CA33", timeout: 3000 })
              this.formDynamic = false
              return
            }
             this.form.reportData = late.reportData || {}
            this.form.images = Array.isArray(late.images) ? late.images : []
            try {
              const keys = new Set((this.form.images || []).map(img => String(img.formFieldKey)))
              keys.forEach(k => this.setImageLoading(k, true))
            } catch (_) {}
            this.formSchema = late.formSchema || {}
            const properties = late.formSchema?.properties || {}
            Object.keys(properties || {}).forEach((secKey) => {
              if (!this.form.reportData[secKey]) {
                if (this.vue && this.vue.$set) {
                  this.vue.$set(this.form.reportData, secKey, {})
                } else {
                  this.form.reportData[secKey] = {}
                }
              }
            })
            this.fields = late.formSchema.properties


            this.form.status = 'DRAFT'
            this.form.submittedDate = late.submittedDate || null
            this.form.approvedDate = late.approvedDate || null

            if (late.formSchema?.['ui:order']) {
                const ordered = late.formSchema['ui:order'].filter(k => properties[k]).map(k => ({ key: k, ...properties[k] }))
                const remaining = Object.entries(properties)
                    .filter(([k]) => !late.formSchema['ui:order'].includes(k))
                    .map(([k, v]) => ({ key: k, ...v }))
                this.fields = [...ordered, ...remaining]
            } else {
                this.fields = Object.entries(properties).map(([key, value]) => ({ key, ...value }))
            }
            if (Array.isArray(this.fields)) {
              this.fields.forEach(sec => {
                if (sec && sec.key && !this.form.reportData[sec.key]) {
                  if (this.vue && this.vue.$set) {
                    this.vue.$set(this.form.reportData, sec.key, {})
                  } else {
                    this.form.reportData[sec.key] = {}
                  }
                }
              })
            }

            this.fields.forEach(f => {
                if (!this.form.reportData[f.key] || typeof this.form.reportData[f.key] !== 'object') {
                    this.form.reportData[f.key] = {}
                }
                const props = f.properties || {}
                if (f['ui:order']) {
                    f.orderedProperties = f['ui:order']
                        .filter(k => Object.prototype.hasOwnProperty.call(props, k))
                        .map(k => [k, props[k]])
                } else {
                    f.orderedProperties = Object.entries(props)
                }
     
                Object.entries(props).forEach(([pKey, pSchema]) => {
                  const secObj = this.form.reportData[f.key]
                  if (!Object.prototype.hasOwnProperty.call(secObj, pKey)) {
                    let initial = null
                    if (pSchema.type === 'string' && pSchema.format !== 'date-time') initial = ''
                    else if (pSchema.type === 'integer') initial = null
                    else if (pSchema.type === 'boolean') initial = null
                    else if (pSchema.format === 'date-time') initial = null
                    else if (pSchema.type === 'array') initial = undefined 
                    if (this.vue && this.vue.$set) this.vue.$set(secObj, pKey, initial)
                    else secObj[pKey] = initial
                  }
                })
            })

            this.form.startedDate = late.startDate
            this.totalProperties = this.fields.length - 1
            this.updateDynamicRequirements()
            this.formDynamic = true
        } else {
            snackbar.show({ message: "ID recebido inválido", color: "#ff0000", timeout: 3000 })
        }
    } catch (error) {
        snackbar.show({ message: error?.toString() || "Erro ao exibir formulário", color: "#ff0000", timeout: 3000 })
    } finally {
      this.loading = false;
    }
  }

  async startedForm() {
    try {
      if (this.form.status != "DRAFT") {
        this.form.status = "DRAFT"
      } else {
          return
      }
      const payload = {
        "status": this.form.status,
        "reportData": this.form.reportData
      }
      await this.patchServiceOrderReportIdReportItemUseCaseImpl(this.form.id, payload)
    } catch(error) {
      this.form.status = ""
    }
  }

  async patchServiceOrderReport(field, fieldKey, sectionKey) {
    try {
      this.loading = true
      if (field && Object.prototype.hasOwnProperty.call(field, 'key')) {
          fieldKey = field.key
      }
      if (!sectionKey && this.fields && this.fields.length) {
          const found = this.fields.find(f => f.properties && Object.prototype.hasOwnProperty.call(f.properties, fieldKey))
          if (found) sectionKey = found.key
      }
      if (sectionKey && !this.form.reportData[sectionKey]) {
        this.form.reportData[sectionKey] = {}
      }
      const key = `${sectionKey || ''}.${fieldKey}`
      let currentVal = sectionKey ? this.form.reportData[sectionKey][fieldKey] : this.form.reportData[fieldKey]
      if (field.format == "date-time" && currentVal && field.readOnly !== true) {
        try { currentVal = dayjs(currentVal).toISOString() } catch (_) {}
        if (sectionKey) this.form.reportData[sectionKey][fieldKey] = currentVal; else this.form.reportData[fieldKey] = currentVal
      }
      if (this.patchTimers[key]) {
        clearTimeout(this.patchTimers[key])
      }
      this.setSavingState(key, true)
      this.setErrorState(key, null)
      this.patchTimers[key] = setTimeout(() => {
        this._doPatch(sectionKey, fieldKey)
      }, 400)
    } catch (error) {
      snackbar.show({ message: error?.toString() || "Não foi possível preparar a atualização do campo", color: "#ff0000", timeout: 3000 })
    } finally {
      this.loading = false
    }
  }

  async _doPatch(sectionKey, fieldKey) {
    const key = `${sectionKey || ''}.${fieldKey}`
    if (this.patchInFlight[key]) {
      this.patchPending[key] = true
      return
    }
    this.patchInFlight[key] = true
    try {
      const snapshot = JSON.parse(JSON.stringify(this.form.reportData))

      let status = 'DRAFT'
      let submittedDate = this.form.submittedDate || null
      if (submittedDate && !this.form.approvedDate) {
        status = 'PENDING_APPROVED'
      }
      const payload = {
        reportData: snapshot,
        status,
        submittedDate,
        approvedDate: this.form.approvedDate || null,
      }
      await this.patchServiceOrderReportIdReportItemUseCaseImpl(this.form.id, payload)
      this.updateDynamicRequirements()
      this.setErrorState(key, null)
    } catch (error) {
      snackbar.show({ message: error?.toString() || "Não foi possível inserir ou atualizar esse campo", color: "#ff0000", timeout: 3000 })
      this.setErrorState(key, error?.toString() || 'Erro ao salvar')
    } finally {
      this.setSavingState(key, false)
      this.patchInFlight[key] = false
      if (this.patchPending[key]) {
        this.patchPending[key] = false
        this._doPatch(sectionKey, fieldKey)
      }
    }
  }

  setSavingState(key, val) {
    this.savingState = { ...this.savingState, [key]: !!val }
  }

  setErrorState(key, message) {
    if (!message) {
      const { [key]: _, ...rest } = this.errorState
      this.errorState = rest
    } else {
      this.errorState = { ...this.errorState, [key]: message }
    }
  }

  isSaving(sectionKey, fieldKey) {
    const key = `${sectionKey || ''}.${fieldKey}`
    return !!this.savingState[key]
  }

  fieldError(sectionKey, fieldKey) {
    const key = `${sectionKey || ''}.${fieldKey}`
    return this.errorState[key] || null
  }

  setUploading(fieldKey, val) {
    if (!fieldKey) return
    this.uploadLoading = { ...this.uploadLoading, [String(fieldKey)]: !!val }
  }

  isUploading(sectionKey, fieldKey) {
    const key = (fieldKey !== undefined && fieldKey !== null) ? String(fieldKey) : String(sectionKey)
    return !!this.uploadLoading[key]
  }

  setImageLoading(fieldKey, val) {
    if (!fieldKey) return
    this.imageLoading = { ...this.imageLoading, [String(fieldKey)]: !!val }
  }

  isImageLoading(sectionKey, fieldKey) {
    const key = (fieldKey !== undefined && fieldKey !== null) ? String(fieldKey) : String(sectionKey)
    return !!this.imageLoading[key]
  }

  onImageLoaded(fieldKey) {
    try {
      this.setImageLoading(fieldKey, false)
    } catch (_) {}
  }

  updateDynamicRequirements() {
    const map = {}
    this.fields.forEach(f => {
      const baseReq = Array.isArray(f.required) ? f.required : []
      map[f.key] = new Set(baseReq)
    })
    const allOf = Array.isArray(this.formSchema?.allOf) ? this.formSchema.allOf : []
    allOf.forEach(rule => {
      const ifProps = rule?.if?.properties || {}
      const thenProps = rule?.then?.properties || {}
      Object.entries(ifProps).forEach(([sectionKey, section]) => {
        const condProps = section?.properties || {}
        Object.entries(condProps).forEach(([propKey, cond]) => {
          const expected = cond?.const
          const current = this.form.reportData?.[sectionKey]?.[propKey]
          if (expected === current) {
            const thenSection = thenProps?.[sectionKey]
            const reqList = thenSection?.required || []
            if (!map[sectionKey]) map[sectionKey] = new Set()
            reqList.forEach(k => map[sectionKey].add(k))
          }
        })
      })
    })
    this.dynamicRequired = map
  }

  isRequired(sectionKey, propKey) {
    const set = this.dynamicRequired?.[sectionKey]
    return !!(set && set.has(propKey))
  }

  rulesFor(sectionKey, propKey, type) {
    if (!this.isRequired(sectionKey, propKey)) return []
    return [v => {
      if (type === 'boolean') return (v === true || v === false) || 'Campo obrigatório'
      if (type === 'array') {
        const uploaded = Array.isArray(this.form.images)
          ? this.form.images.some(img => img?.formFieldKey === propKey)
          : false
        const hasInput = (Array.isArray(v) && v.length > 0) || (!!v && v.name)
        return (uploaded || hasInput) || 'Campo obrigatório'
      }
      return (v !== undefined && v !== null && String(v).trim().length > 0) || 'Campo obrigatório'
    }]
  }

  async compressImageToJpeg(file, quality = 0.5) {
    const blob = file instanceof Blob ? file : new Blob([file])
    const imgBitmap = await createImageBitmap(blob)
    const canvas = document.createElement('canvas')
    canvas.width = imgBitmap.width
    canvas.height = imgBitmap.height
    const ctx = canvas.getContext('2d')
    ctx.drawImage(imgBitmap, 0, 0)
    return await new Promise((resolve, reject) => {
      canvas.toBlob(
        b => (b ? resolve(b) : reject(new Error('Falha ao converter imagem'))),
        'image/jpeg',
        quality
      )
    })
  }

  async convertToJpeg(file, quality = 0.3) {
    try {
      const name = (file?.name || '').toLowerCase()
      const type = (file?.type || '').toLowerCase()
      const isHeic = type === 'image/heic' || type === 'image/heif' || name.endsWith('.heic') || name.endsWith('.heif')
      const isAvif = type === 'image/avif' || name.endsWith('.avif')
      const isRaw = /\.(raw|dng|arw|cr2|nef)$/i.test(name)

      if (isHeic) {
        try {
          let heic2anyFn = null
          try {
            const mod = await import('heic2any')
            heic2anyFn = mod?.default || mod
          } catch (_) {}
          if (heic2anyFn) {
            const out = await heic2anyFn({ blob: file, toType: 'image/jpeg', quality })
            return out instanceof Blob ? out : new Blob([out], { type: 'image/jpeg' })
          }
          return await this.compressImageToJpeg(file, quality)
        } catch (e) {
          snackbar.show({ message: 'Não foi possível converter HEIC/HEIF para JPEG neste navegador.', color: '#ff0000', timeout: 3000 })
          throw e
        }
      }
      if (isAvif) {
        try {
          return await this.compressImageToJpeg(file, quality)
        } catch (e) {
          snackbar.show({ message: 'Não foi possível converter AVIF para JPEG neste navegador.', color: '#ff0000', timeout: 3000 })
          throw e
        }
      }
      if (isRaw) {
        try {
          return await this.compressImageToJpeg(file, quality)
        } catch (e) {
          snackbar.show({ message: 'Formato RAW não é suportado para conversão no navegador. Envie como JPEG/PNG/HEIC/AVIF.', color: '#ff0000', timeout: 4000 })
          throw e
        }
      }
      return await this.compressImageToJpeg(file, quality)
    } catch (err) {
      throw err
    }
  }

  async serviceOrderReportImage(files, fieldKey) {
    const list = Array.isArray(files) ? files : (files && files.name ? [files] : [])
    if (!list.length) return false
    this.setUploading(fieldKey, true)
    let anySuccess = false
    try {
      for (const image of list) {
        try {
          const jpegBlob = await this.convertToJpeg(image, 0.3)
          const formImage = {
            contentType: 'image/jpeg',
            fileName: `${fieldKey}.jpeg`,
            formFieldKey: fieldKey,
            serviceOrderReportID: this.form.id,
            fileSize: jpegBlob.size
          }
          const response = await this.createServiceOrderReportImageUseCaseImpl(formImage)
          if (!response?.signURL) {
            snackbar.show({ message: 'Não foi possível preparar o upload da imagem', color: '#ff0000', timeout: 3000 })
            continue
          }
          try {
            Object.defineProperty(jpegBlob, 'type', { value: 'image/jpeg' })
            await this.changeServiceOrderReportImageUseCaseImpl(response.signURL, jpegBlob)
            const payload = {
              serviceOrderReportId: formImage.serviceOrderReportID,
              s3Key: response.s3Key,
              formFieldKey: response.formFieldKey,
              caption: ""
            }
            await this.createConfirmImageUploadUseCaseImpl(payload)
            anySuccess = true
          } catch (error) {
            snackbar.show({ message: error?.toString() || 'Falha ao enviar/confirmar a imagem', color: '#ff0000', timeout: 3000 })
          }
        } catch (inner) {
          snackbar.show({ message: inner?.toString() || 'Falha ao processar a imagem', color: '#ff0000', timeout: 3000 })
        }
      }

      try {
        const resp = await this.getServiceOrderByIDReportUseCaseImpl(this.form.id)
        this.form.images = resp.images || []
      } catch (_) {}
      return anySuccess
    } catch (error) {
      snackbar.show({ message: error?.toString() || 'Não foi possível enviar a imagem', color: '#ff0000', timeout: 3000 })
      return false
    } finally {
      this.setUploading(fieldKey, false)
    }
  }

  async generateReport(item) {
    try {
        this.loading = true
         const reportData = await this.getServiceOrderByIDReportUseCaseImpl(item.id)
        await new ServiceOrderReport().call(reportData)
    } catch (error) {
        console.error('Erro ao baixar relatório:', error)
    } finally {
        this.loading = false
    }
  }

 onTabChange() {
    const nextIdx = Number(this.tabs)

    if (Number.isNaN(nextIdx)) return;

    if (this.constraints.video) {
      const prevId = this.constraints.id
      this.stopVideo()
      this.constraints.video = false
      this.clearCameraReference(prevId)
    }

    this.currentTab = this.tabs
    this.loading = false
  }

 _isSectionValid(section) {
    return true;
  }

  async sendDate() {
    try {
        const currentReport = await this.getServiceOrderByIDReportUseCaseImpl(this.form.id)
        
        const startDate = { 
            ...currentReport.reportData, 
            startDate: this.form.startedDate
        }

        await this.patchServiceOrderReportIdReportItemUseCaseImpl(this.form.id, startDate) 
    }catch (err) {
        console.log(err);
    }
  } 

  closeFormDynamic() {
    this.clearAllCameras()
    this.cancelPendingPatches() 
    this.loading = false
    this.formDynamic = false
    
    this.form = VisitServiceOrderDefault()
    this.fields = []
    this.formSchema = null
    this.dynamicRequired = {}
    this.errorState = {}
    this.savingState = {}
    this.uploadLoading = {}
    this.imageLoading = {}
    this.currentTab = 0
    this.tabs = 0
  }

  async retakePhoto(field, index) {
  if (field.key) {
    index = field.key
  }
  
  this.photoMode[index] = false
  delete this.photoData[index]
  
  try {
    const current = Array.isArray(this.form.images) ? this.form.images : []
    this.form.images = current.filter(img => img?.formFieldKey !== index)
  } catch (_) {}
  
  await this.initializeCamera(field, index)
}
}

export default VisitServiceOrderController